import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

import RaindropCardStripe from "../../../ui-components/raindrop-card-stripe-card/raindrop-card-stripe-card.tsx";
import { useEffect, useState } from "react";
import { fetchGetStripeClientSecret } from "../../../services/api-raindrop.js";

const KindnessTitle = ({ text }) => {
  return <div className="text-2xl font-bold ">{text}</div>;
};

const RaindropPaymentMethodAdd = ({ userCurrent }) => {
  const [stripeClientSecret, setStripeClientSecret] = useState("");

  const accountId = userCurrent.account.id;

  useEffect(() => {
    fetchGetStripeClientSecret({ accountId: accountId })
      .then((data) => setStripeClientSecret(data["client_secret"]))
      .catch((error) => console.error("🔴 (RD-352) - ", error));
  }, [accountId, setStripeClientSecret]);

  return (
    <div
      id="page-card-details"
      className={"flex flex-col h-full w-full items-center gap-4 py-8"}
    >
      <div className="flex flex-col gap-4 w-full h-full max-w-md">
        <KindnessTitle text={"Add a payment method to your account"} />
        <RaindropTextParagraph>
          Payment information is securely stored with Stripe. Raindrop does not
          store any payment information.
        </RaindropTextParagraph>

        <RaindropCardStripe
          accountId={userCurrent.account.id}
          stripeClientSecret={stripeClientSecret}
        />

        <p className="dark:text-color-dark-text-secondary text-color-text-secondary p-6 text-xs text-center w-full max-w-sm opacity-50">
          Copyright © 2025 The Raindrop Group Limited. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default RaindropPaymentMethodAdd;
